import { Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";

import { FlowEditContext } from "../../FlowEditContext";
import {
    FlowStepOutputInstructions,
    FlowStepOutputInstructionType,
} from "../../../rule-engine-core/Flow/Structure/FlowStepOutputInstructions";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowConfiguration } from "../../../rule-engine-core/Flow/FlowConfiguration";
import { RenderStepInstruction } from "./RenderStepInstruction";
import { FlowStepSequenceType } from "../../../rule-engine-core/Flow/Structure/FlowStepSequenceType";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const InstructionsDiv = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
`;

const FlowSequenceTitleDiv = styled.div<{ isSpecial?: boolean }>`
    display: flex;
    align-items: center;

    cursor: default;

    .MuiTypography-root {
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

        &.MuiTypography-h4 {
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 120%;
            margin-right: 5px;
        }

        &.MuiTypography-caption {
            font-style: normal;
            font-weight: bold;
            font-size: 8px;
            line-height: 140%;
        }
    }
`;

const FlowSequenceSummary = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;

interface IRegularCollapsedStack {
    flow: FlowConfiguration;
    editContext: FlowEditContext;
    sequence: FlowStepSequence;
}

export const RenderCollapsedStack: React.FC<IRegularCollapsedStack> = (props) => {
    const Intructions = (
        <InstructionsDiv>
            {props.sequence.instructions
                .filter(
                    (ins) =>
                        props.sequence.endStep._id !== ins.stepId &&
                        ins.strategy !== FlowStepOutputInstructionType.BRANCH &&
                        ins.strategy !== FlowStepOutputInstructionType.CONTINUE,
                )
                .map((ins: FlowStepOutputInstructions, idx) => (
                    <RenderStepInstruction
                        editContext={props.editContext}
                        instruction={ins}
                        hideLabel
                        key={idx}
                    />
                ))}
        </InstructionsDiv>
    );

    return (
        <div>
            <FlowSequenceSummary>
                {props.sequence.sequenceType === FlowStepSequenceType.BRANCH_MERGE && (
                    <FlowSequenceTitleDiv style={{ paddingRight: "10px" }}>
                        <Typography
                            align="center"
                            variant="h4"
                            data-testid="steps-count"
                        >
                            {props.sequence.branches.length}
                        </Typography>
                        <Typography
                            align="center"
                            variant="caption"
                        >
                            Branches
                        </Typography>
                    </FlowSequenceTitleDiv>
                )}

                <FlowSequenceTitleDiv>
                    <Typography
                        align="center"
                        variant="h4"
                        data-testid="steps-count"
                    >
                        {props.sequence.allStepsWithoutEnd().length}
                    </Typography>
                    <Typography
                        align="center"
                        variant="caption"
                    >
                        Steps
                    </Typography>
                </FlowSequenceTitleDiv>
                {props.sequence.isNormal && <>{Intructions}</>}
            </FlowSequenceSummary>
        </div>
    );
};
